import { getThemeType } from './env'
import { isHLApp } from './index'

// 保存监听器引用，用于后续移除
let darkModeListener = null
let mediaQuery = null

/**
 * 自动设置 html 的暗色模式类
 * - app 中根据 getThemeType()
 * - 非 app 根据系统主题
 * - 非 app 自动监听系统主题变化
 */
export function applyDarkMode() {
    const html = document.documentElement

    // 设置 html dark 类
    const updateHtmlClass = () => {
        if (isLightTheme()) {
            html.classList.remove('dark')
        } else {
            html.classList.add('dark')
        }
    }

    // 先执行一次，设置初始主题
    updateHtmlClass()

    // 非 app 环境，监听系统主题变化
    if (!isHLApp()) {
        mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
        darkModeListener = updateHtmlClass
        mediaQuery.addEventListener('change', darkModeListener)
    }
}

/**
 * 取消应用 dark 模式
 * - 移除 dark 类
 * - 移除系统主题变化监听器
 */
export function removeDarkMode() {
    const html = document.documentElement

    // 移除 dark 类
    html.classList.remove('dark')

    // 移除事件监听器
    if (mediaQuery && darkModeListener) {
        mediaQuery.removeEventListener('change', darkModeListener)
        mediaQuery = null
        darkModeListener = null
    }
}

/**
 * 判断是否为浅色主题
 */
export function isLightTheme() {
    if (isHLApp()) {
        return getThemeType() === 'white'
    }
    return window.matchMedia('(prefers-color-scheme: light)').matches
}
